import {makeAutoObservable, observable} from "mobx";
import {ViewController} from "data/types/structure";
import {inject, injectable} from "inversify";
import type {ILocalizationStore} from "data/stores/localization/localization.store";
import {Bindings} from "data/constants/bindings";
import type {ILightPredictionsStore} from "data/stores/light_predictions/light_predictions.store";
import {GameSteps, ModalType} from "data/enums";
import type {IModalsStore} from "data/stores/modals/modals.store";
import type {IShareStore} from "data/stores/share/share.store";
import {useNavigate} from "react-router-dom";
import type {IRoundsStore} from "data/stores/rounds/rounds.store";

interface IProps {
	navigate: ReturnType<typeof useNavigate>;
}

export interface ILPSavedCardController extends ViewController<IProps> {
	readonly i18n: ILocalizationStore;
	get predictionUpdateDate(): string | null;
	get isLockout(): boolean;

	onEditPicks: () => void;
	onOpenShareModal: () => void;
	onExplore: () => void;
}

@injectable()
export class LPSavedCardController implements ILPSavedCardController {
	@observable private _navigate?: ReturnType<typeof useNavigate>;
	get predictionUpdateDate() {
		return this._lpStore.predictionUpdateDate;
	}

	get isLockout() {
		return this._roundStore.isRoundsLockout;
	}

	constructor(
		@inject(Bindings.LocalizationStore) readonly i18n: ILocalizationStore,
		@inject(Bindings.RoundsStore) private _roundStore: IRoundsStore,
		@inject(Bindings.LightPredictionsStore) private _lpStore: ILightPredictionsStore,
		@inject(Bindings.ModalsStore) private _modalsStore: IModalsStore,
		@inject(Bindings.ShareStore) private _shareStore: IShareStore
	) {
		makeAutoObservable(this);
	}

	onEditPicks = () => {
		this._lpStore.setHasSavedPredictions(false);
		this._lpStore.setCurrentStep(GameSteps.NFC_EAST);
	};

	onOpenShareModal = () => {
		void this._shareStore.sharePredictionImage();
		this._modalsStore.showModal(ModalType.SHARE_PICKS, {
			message: "",
		});
	};

	onExplore = () => {
		this._navigate?.("/game-by-game", {replace: true});
	};

	init({navigate}: IProps) {
		this._navigate = navigate;
	}
}
